import { FallbackReportService } from './local-service/fallback-report.service';
import { DataSourceService } from './data-source.service';
import { FallbackReportRoutingModule } from './fallback-report-routing.module';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ButtonModule, CardModule, DropdownModule } from '@eucoms/common-components';
import { SafePipe } from './table/pipes/safe/safe.pipe';
import { FormatCelPipe } from './table/pipes/format-cel/format-cel.pipe';
import { OutagesNoticeComponent } from './outages-notice/outages-notice.component';
import { TableNavComponent } from './table-nav/table-nav.component';
import { TableComponent } from './table/table.component';
import { FallbackReportComponent } from './fallback-report.component';
import { ThousandsPipe } from './table/pipes/thousands/thousands.pipe';
import { MoreInfoComponent } from './more-info/more-info.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    FallbackReportRoutingModule,
    ButtonModule,
    CardModule,
    DropdownModule
  ],
  providers: [
    DataSourceService,
    FallbackReportService
  ],
  declarations: [
    FallbackReportComponent,
    TableComponent,
    SafePipe,
    FormatCelPipe,
    OutagesNoticeComponent,
    TableNavComponent,
    ThousandsPipe,
    MoreInfoComponent
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA ]
})
export class FallbackReportModule { }
